import Blockly from "blockly";
import {
  Bosses,
  Cards,
  Characters,
  Consumables,
  Costumes,
  Curses,
  Enemies,
  Monsters,
  Pills,
  PoopSpells,
  Rooms,
  Trinkets,
} from '../data';

export const menu = {
  'data_cards': {
    name: (<div className="text"><u>C</u>ards/Runes</div>),
    trigger: 'c',
  },
  'data_characters': {
    name: (<div className="text">C<u>h</u>aracters</div>),
    trigger: 'h',
  },
  'data_consumables': {
    name: (<div className="text">C<u>o</u>nsumables</div>),
    trigger: 'o',
  },
  'data_costumes': {
    name: (<div className="text">Costu<u>m</u>es</div>),
    trigger: 'm',
  },
  'data_curses': {
    name: (<div className="text">C<u>u</u>rses</div>),
    trigger: 'u',
  },
  'data__enemies': {
    name: (<div className="text"><u>E</u>nemies</div>),
    trigger: 'e',
    children: {
      'data_enemies': {
        name: (<div className="text"><u>A</u>ll Enemies</div>),
        trigger: 'a',
      },
      'data_bosses': {
        name: (<div className="text"><u>B</u>osses</div>),
        trigger: 'b',
      },
      'data_monsters': {
        name: (<div className="text"><u>M</u>onsters</div>),
        trigger: 'm',
      },
      'random_enemy': {
        name: (<div className="text"><u>R</u>andom Enemy</div>),
        trigger: 'r',
      },
      'random_boss': {
        name: (<div className="text">Random Bo<u>s</u>s</div>),
        trigger: 's',
      },
      'random_monster': {
        name: (<div className="text">Random M<u>o</u>nster</div>),
        trigger: 'o',
      },
    },
  },
  'data_pills': {
    name: (<div className="text"><u>P</u>ills</div>),
    trigger: 'p',
  },
  'data_rooms': {
    name: (<div className="text">R<u>o</u>oms</div>),
    trigger: 'o',
  },
  'data_stats': {
    name: (<div className="text"><u>S</u>tat</div>),
    trigger: 's',
  },
  'data_trinkets': {
    name: (<div className="text"><u>T</u>rinkets</div>),
    trigger: 't',
  },
  'data_poopspells': {
    name: (<div className="text">Poop Spe<u>l</u>ls</div>),
    trigger: 'l',
  },
  /*
  'define_group': {
    name: (<div className="text"><u>D</u>efine Data Group</div>),
    trigger: 'd'
  },
  'group_get': {
    name: (<div className="text"><u>G</u>et Random from Data Group</div>),
    trigger: 'g'
  },
  */
}

/* ****************************************************************************************************************
 * Card
 *
 * Specifies a Card selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_cards'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Card')
      .appendField(new Blockly.FieldDropdown(
        [['Random Card/Rune', '-1']].concat(
          Cards.sort((a, b) => a[0] > b[0] ? 1 : -1)
        )
      ), 'Card');
    this.setOutput(true, ['card', 'usable']);
  }
}

Blockly.JSON['data_cards'] = (block) => {
  let value = block.getFieldValue('Card');

  return {
    type: 'card',
    entity_id: parseInt(value, 10),
  }
}

/* ****************************************************************************************************************
 * Characters
 *
 * Specifies a Characters selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_characters'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Character')
      .appendField(
        new Blockly.FieldDropdown(
          [['Random Character', '-1']].concat(
            Characters.sort((a, b) => a[0] > b[0] ? 1 : -1)
          )
        ),
        'Character'
      );
    this.setOutput(true, ['character']);
  }
}

Blockly.JSON['data_characters'] = (block) => {
  let value = block.getFieldValue('Character');

  return {
    type: 'character',
    entity_id: parseInt(value, 10),
  }
}

/* ****************************************************************************************************************
 * Costumes
 *
 * Specifies a Costume selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_costumes'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Costume')
      .appendField(
        new Blockly.FieldDropdown(
          [['Random Costume', '-1']].concat(
            Costumes.sort((a, b) => a[0] > b[0] ? 1 : -1)
          )
        ),
        'Costume'
      );
    this.setOutput(true, ['costume']);
  }
}

Blockly.JSON['data_costumes'] = (block) => {
  let value = block.getFieldValue('Costume');

  return {
    type: 'costume',
    entity_id: parseInt(value, 10),
  }
}

/* ****************************************************************************************************************
 * Consumables
 *
 * Specifies a Consumable selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_consumables'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Consumables')
      .appendField(new Blockly.FieldDropdown(
        [['Random Consumable', '-1']].concat(
          Consumables
        )
      ), 'Consumable');
    this.setOutput(true, ['consumable', 'spawnable']);
  }
}

Blockly.JSON['data_consumables'] = (block) => {
  let value = JSON.parse(block.getFieldValue('Consumable'));

  return {
    type: 'consumable',
    entity: {
      id: parseInt(value['id'], 10),
      subtype: parseInt(value['subtype'], 10),
      variant: parseInt(value['variant'], 10),
    },
  };
}


/* ****************************************************************************************************************
 * Stats
 *
 * Specifies a stats selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_stats'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setMinimum(-420.69);
    shadow.setMaximum(420.69);
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Stats')
      .appendField(new Blockly.FieldDropdown([
        ['Random', 'random'],
        ['Damage', 'damage'],
        ['Fire', 'fire'],
        ['Luck', 'luck'],
        ['Range', 'range'],
        ['Shot', 'shot'],
        ['Speed', 'speed'],
      ]), 'Stat')
      .appendField('to')
      .connection
      .connect(shadow.outputConnection);
    this.setInputsInline(false);

    this.setOutput(true, ['stat']);
  }
}

Blockly.JSON['data_stats'] = (block) => {
  let stat = block.getFieldValue('Stat');
  let value = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);

  return {
    stat,
    value: parseFloat(value['value'], 10),
  };
}
/* ****************************************************************************************************************
 * Curses
 *
 * Specifies a Curse selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_curses'] = {
  init: function () {
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown(
        [['Random Curse', '-1']].concat(
          Curses
        )
      ), 'Curse');
    this.setOutput(true, ['curse']);
  }
}

Blockly.JSON['data_curses'] = (block) => {
  let value = block.getFieldValue('Curse');

  return {
    type: 'curse',
    entity_id: value,
  }
}

/* ****************************************************************************************************************
 * Pills
 *
 * Specifies a Pill selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_pills'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Pill')
      .appendField(new Blockly.FieldDropdown(
        [['Random Pill', '-1']].concat(
          Pills.sort((a, b) => a[0] > b[0] ? 1 : -1)
        )
      ), 'Pill');
    this.setOutput(true, ['pill', 'usable']);
  }
}

Blockly.JSON['data_pills'] = (block) => {
  let value = block.getFieldValue('Pill');

  return {
    type: 'pill',
    entity_id: parseInt(value, 10),
  }
}

/* ****************************************************************************************************************
 * Rooms
 *
 * Specifies a Room selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_rooms'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Room')
      .appendField(new Blockly.FieldDropdown(
        [['Random Room', '-1']].concat(
          Rooms.sort((a, b) => a[0] > b[0] ? 1 : -1)
        )
      ), 'Room');
    this.setOutput(true, ['room']);
  }
}

Blockly.JSON['data_rooms'] = (block) => {
  let value = block.getFieldValue('Room');

  return {
    type: 'room',
    entity_id: parseInt(value, 10),
  }
}

/* ****************************************************************************************************************
 * Trinkets
 *
 * Specifies a Trinket selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_trinkets'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Trinket')
      .appendField(new Blockly.FieldDropdown(
        [['Random Trinket', '-1']].concat(
          Trinkets.sort((a, b) => a[0] > b[0] ? 1 : -1)
        )
      ), 'Trinket');
    this.setOutput(true, ['trinket']);
  }
}

Blockly.JSON['data_trinkets'] = (block) => {
  let value = block.getFieldValue('Trinket');

  return {
    type: 'trinket',
    entity_id: parseInt(value, 10),
  };
}

/* ****************************************************************************************************************
 * Enemies
 *
 * Specifies an Enemy selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_enemies'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Enemies')
      .appendField(new Blockly.FieldDropdown(
        [['Random Enemy', '-1']].concat(
          Enemies.sort((a, b) => a[0] > b[0] ? 1 : -1)
        )
      ), 'Enemy');
    this.setOutput(true, ['enemy']);
  }
}

Blockly.JSON['data_enemies'] = (block) => {
  let value = JSON.parse(block.getFieldValue('Enemy'));

  console.log(value);

  return {
    type: 'enemy',
    entity: {
      id: parseInt(value['id'], 10),
      subtype: parseInt(value['subtype'], 10),
      variant: parseInt(value['variant'], 10),
    },
  };
}

/* ****************************************************************************************************************
 * Bosses
 *
 * Specifies a Bosses selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_bosses'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Bosses')
      .appendField(new Blockly.FieldDropdown(
        [['Random Boss', '-1']].concat(
          Bosses.sort((a, b) => a[0] > b[0] ? 1 : -1)
        )
      ), 'Enemy');
    this.setOutput(true, ['enemy']);
  }
}

Blockly.JSON['data_bosses'] = (block) => {
  let value = JSON.parse(block.getFieldValue('Enemy'));

  return {
    type: 'enemy',
    entity: {
      id: parseInt(value['id'], 10),
      subtype: parseInt(value['subtype'], 10),
      variant: parseInt(value['variant'], 10),
    },
  };
}

/* ****************************************************************************************************************
 * Monsters
 *
 * Specifies a Monsters selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_monsters'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Monsters')
      .appendField(new Blockly.FieldDropdown(
        [['Random Monster', '-1']].concat(
          Monsters.sort((a, b) => a[0] > b[0] ? 1 : -1)
        )
      ), 'Enemy');
    this.setOutput(true, ['enemy']);
  }
}

Blockly.JSON['data_monsters'] = (block) => {
  let value = JSON.parse(block.getFieldValue('Enemy'));

  return {
    type: 'enemy',
    entity: {
      id: parseInt(value['id'], 10),
      subtype: parseInt(value['subtype'], 10),
      variant: parseInt(value['variant'], 10),
    },
  };
}

/* ****************************************************************************************************************
 * Random Enemies
 *
 * Specifies an Enemy selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['random_enemy'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Random Enemy')
    this.setOutput(true, ['enemy', 'spawnable']);
  }
}

Blockly.JSON['random_enemy'] = (block) => {
  return {
    type: 'enemy',
    entity: {
      id: -1,
      subtype: -1,
      variant: -1
    }
  };
}

/* ****************************************************************************************************************
 * Random Boss
 *
 * Specifies an Enemy selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['random_boss'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Random Boss')
    this.setOutput(true, ['enemy', 'spawnable']);
  }
}

Blockly.JSON['random_boss'] = (block) => {
  return {
    type: 'boss',
    entity: {
      id: -1,
      subtype: -1,
      variant: -1
    }
  };
}
/* ****************************************************************************************************************
 * Random Enemies
 *
 * Specifies an Enemy selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['random_monster'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Random Monster')
    this.setOutput(true, ['enemy', 'spawnable']);
  }
}

Blockly.JSON['random_monster'] = (block) => {
  return {
    type: 'monster',
    entity: {
      id: -1,
      subtype: -1,
      variant: -1
    }
  };
}

/* ****************************************************************************************************************
 * Poop Spells
 *
 * Specifies a Poop Spell selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['data_poopspells'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Poop Spell')
      .appendField(
        new Blockly.FieldDropdown(
          [['Random Poop Spell', '-1']].concat(
            PoopSpells.sort((a, b) => a[0] > b[0] ? 1 : -1)
          )
        ),
        'PoopSpell'
      );
    this.setOutput(true, ['poopspell']);
  }
}

Blockly.JSON['data_poopspells'] = (block) => {
  let value = block.getFieldValue('PoopSpell');

  return {
    type: 'spell',
    spell_id: parseInt(value, 10),
  }
}
